<template>
	<div class="jurisdiction_web">
		<headdv :headTitle="headTitle" :isBackShow="false" :goPath="goPatHead" :activeWebTitle = 'activeWebTitle'></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<div class="header flex-row">
					<div></div>
					<!-- <el-page-header @back="goBack"></el-page-header> -->
					<div class="title">数据分析</div>
					<div></div>
					<!-- <div class="add" @click="addManager">添加</div> -->
				</div>
				<div class="content">
					<el-table	:data="tableData"	style="width: 100%;margin-bottom: 20px;"	row-key="id"	align="left"
						:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
						<el-table-column	prop="an_id"	label="小说名"	min-width="120"></el-table-column>
						<el-table-column	prop="an_name"	label="访问页面"	min-width="200"></el-table-column>
						<el-table-column	prop="an_pid"	label="小说id"	min-width="120"></el-table-column>
						<el-table-column	prop="an_pid"	label="分组id"	min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="访问IP"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="设备"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="来源页"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="当天pv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="当天uv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="周pv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="周uv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="月pv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="月uv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="季pv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="季uv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="年pv"		min-width="120"></el-table-column>
						<el-table-column	prop="an_url"	label="年uv"		min-width="120"></el-table-column>
					</el-table>
				</div>
				<!--分页-->
            <page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		<!-- 编辑/添加 -->
		<el-dialog :visible.sync="dialogVisible" width="500px" class="dialog">
			<div class="dialog-title" slot="title">{{isEditOrAdd?'修改':'添加'}}</div>
			<!-- 内容区 start-->
			<el-form ref="staffForm" :rules="rules" :model="staffForm" label-width="120px">
				<el-form-item label="分组id:" prop="an_pid">
					<el-input v-model="staffForm.an_pid" placeholder=""></el-input>
				</el-form-item>
				<el-form-item label="权限名称:" prop="an_name">
					<el-input type="" v-model="staffForm.an_name" placeholder="请输入权限节点名称"></el-input>
				</el-form-item>
				<el-form-item label="权限路径:" prop="an_url">
					<el-input type="" v-model="staffForm.an_url" placeholder="请输入权限节点路径"></el-input>
				</el-form-item>
				<el-form-item label="是否显示:" prop="an_is_show">
					<el-switch v-model="staffForm.an_is_show" inactive-text="否" active-text="是" :inactive-value="0" :active-value="1" ></el-switch>
				</el-form-item>
				<el-form-item label="是否目录:" prop="an_is_file">
					<el-switch v-model="staffForm.an_is_file" inactive-text="否" active-text="是" :inactive-value="0" :active-value="1" ></el-switch>
				</el-form-item>
				
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="resetForm('staffForm')">取 消</el-button>
				<el-button type="primary" @click="saveForm('staffForm')">保 存</el-button>
			</span>
		</el-dialog>
		<!-- 删除 -->
		<el-dialog :visible.sync="delDate.status" width="400px" class="dialog">
			<div class="dialog-title" slot="title">删除</div>
			<!-- 内容区 start-->
			<span>确定删除?</span>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="delDate.status=false">取 消</el-button>
				<el-button type="primary" @click="allDeleteEvent">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			tableData: [],
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			activeWebTitle:'首页',
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 10, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			delarr: [], //存放删除的数据
			//删除弹窗
			delDate: {
				title: "删除账号",
				label: "删除数据不可恢复，确定删除？",
				status: false,
			},
			//分组id
			problemArrId_type: [],
			accountList: [], //列表数据
			checkedList: [], //选中的绑定值
			headTitle: "子后台管理",
			goPatHead: "account",
			dialogVisible: false,   //开启验证
			isEditOrAdd: false, //判断是添加还是编辑，true为编辑/false为添加
         //修改编辑的数据
			staffForm: {
				an_id:'',
				an_pid:0,
				an_name: "",
				an_url: "",
				an_is_show: "",
				an_is_file: "",
			},
			
			//验证规则
			rules: {
				ks_title: [
					{ an_pid: true, message: "请输入分组id", trigger: "blur" }
					//{ ks_title: true, message: "请输入客服系统名字", trigger: "blur" },
					// { min: 1, max: 10, message: "长度在 1 到 20 个字符", trigger: "blur" },
				],
				an_name: [{ required: true, message: "请输入权限名称", trigger: "blur" }],
				an_url: [{ required: true, message: "请输入权限路径", trigger: "blur" }],
			},
		};
	},
	created() {
		this.getTableData();
		console.log(document.documentElement.clientHeight) // 屏幕高度)
	},
	methods: {
		
		//获取1级分类列表数据   //搜索按钮
		getTableData() {
			let get = `?limit=${this.pagesize}&page=${this.pageindex}`
				this.https(this.apiList.getNodeList+`${get}`).then(
				response => {
					response.data.data.forEach(item => {
						//element table  不兼容an_id 所以转换
						item.id = item.an_id
					})
					this.classList = response.data.data;
					this.tableData = this.transTree(this.classList)
					//弹窗提示
					this.tc_element(response.data.msg,response.data.code,2,"获取分类列表")
				}
			);
		},
		//转数结构
		transTree(data) {
			let result = []
			let map = {}
			if (!Array.isArray(data)) {//验证data是不是数组类型
				return []
			}
			data.forEach(item => {//建立每个数组元素id和该对象的关系
				map[item.id] = item //这里可以理解为浅拷贝，共享引用
			})
			data.forEach(item => {
				let parent = map[item.an_pid] //找到data中每一项item的爸爸
				if (parent) {//说明元素有爸爸，把元素放在爸爸的children下面
					(parent.children || (parent.children = [])).push(item)
				} else {//说明元素没有爸爸，是根节点，把节点push到最终结果中
					result.push(item) //item是对象的引用
				}
			})
			return result //数组里的对象和data是共享的
		},
			
		/**
		 * 点击表格  手风琴效果
		*/
		toggleRowExpansion(row, expanded) {
			if(this.currentExpandRow !== undefined && row != this.currentExpandRow) {
				this.$refs.table.toggleRowExpansion(this.currentExpandRow, false); //则行关闭方法
			}
			this.currentExpandRow = row;
			return expanded; //返回状态
		},
		cellstyleFun({row,column,rowIndex,columnIndex}){
			return 'miyao_dv'
		},
		//跳转管理
		goHrefFun(row){
			console.log(row.ks_id)
			this.$router.push({ 
				path: "/admin/khhref" ,
				query:{
						id: row.ks_id,
		  		}
		  });
		},
		//格式化内容--部门		
		formatter_ar_id(row, column, cellValue, index) {
			for (let i = 0; i < this.problemArrId_type.length; i++) {
				if (cellValue == this.problemArrId_type[i].ar_id) {
					return this.problemArrId_type[i].ar_name;
				}
			}
		},
		//返回
		goBack() {
			this.$router.go(-1);
		},
		
		//添加二级节点  
		addTangChuan(row) {
			this.dialogVisible = true
			this.staffForm.an_pid = row.an_id
			this.staffForm.an_is_file = 0
		},
		// 点击添加按钮--头部
		addManager() {
			this.staffForm = {
				an_id:'',
				an_pid:0,
				an_name: "",
				an_url: "",
				an_is_show: 0,
				an_is_file: 1,
			}
			this.dialogVisible = true;
			this.isEditOrAdd = false;
		},
		//添加--的确定
		createAccount() {
			let fromData = {}
			for(let key in this.staffForm){
				if(key != 'an_id'){
					fromData[key] = this.staffForm[key]
				}
			}
			this.https(this.apiList.addNode, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					this.getTableData();
					for(let key in this.staffForm){
						this.staffForm[key] = ''
					}
					this.staffForm = {
						an_id:'',
						an_pid:0,
						an_name: "",
						an_url: "",
						an_is_show: 0,
						an_is_file: 1,
					}
					this.tc_element(response.data.msg, response.data.code, 2, "添加");
				}
				this.dialogVisible = false; //隐藏提示框
				
			});
		},
		
		//点击编辑事件   显示修改弹窗
		editTangChuan(row) {
			this.dialogVisible = true;
			this.isEditOrAdd = true;
			for(let key in row){
				this.staffForm[key] = row[key]
			}
		},
		//编辑弹窗   确定按钮
		createAccount_bianji() {
			let fromData = {}
			for(let key in this.staffForm){
				fromData[key] = this.staffForm[key]
			}
			this.https(this.apiList.updateNode, fromData).then((response) => {
				if (response.data.code == this.common.code) {
					this.getTableData();
					this.tc_element(	response.data.msg,	response.data.code,	2,	"编辑");
				}
				this.dialogVisible = false;
			});
		},
		//点击删除按钮  的点击事件
		handleDeleteClick(row) {
			console.log(row)
			if(row.children){
				if(row.children.length > 0){
					this.$message.error("请先删除子节点");
					return false
				}
			}
			
			this.delDate.status = true;
			const id = row.an_id;
			this.delarr.push(id);
		},
		//点击批量删除按钮  的点击事件
		AllDeleteClick(row) {
			this.delDate.status = true;
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				this.delarr.push(this.multipleSelection[i].id);
			}
		},
		//点击删除弹窗的确定按钮
		allDeleteEvent() {
			let fromData = {}
			let id = this.delarr[0];
			fromData.an_id = id;
			this.https(this.apiList.deleteNode, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					//删除后防止页面对不上
					if (this.accountList.length <= 1) {
						if (this.pageData.pageindex == 1) {
							this.pageData.pageindex = 1;
						} else {
							this.pageData.pageindex--;
						}
					}
					this.getTableData();
					this.tc_element(response.data.msg, response.data.code, 2, "删除");
				}
				this.delDate.status = false; //隐藏提示框
				this.delarr = [];
			});
		},
		// 保存 
		saveForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 校验通过
					this.dialogVisible = false;
					if (this.isEditOrAdd) {
						//  编辑
						this.createAccount_bianji()
					} else {
						//  添加
						this.createAccount()
					}
				} else {
					//验证失败
					console.log("error submit!!");
					return false;
				}
			});
		},
		//编辑/添加--取消
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false;
		},
		//删除-取消
		deleteRow() {
			this.delDate.status = false;
		},
		//分页
		//pageSize 改变时会触发    每页条数
		handleSizeChange(val) {
			console.log(val)
			this.pageData.pagesize = val 
			this.getclasslist();
		},
		//currentPage 改变时会触发     当前页
		handleCurrentChange(val) {
			console.log(val)
			this.pageData.pageindex = val
			this.getclasslist();
		},
	},
};
</script>
<style lang="scss">

.miyao_dv{
	.cell{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
}
</style>
<style lang="scss" scoped>

.header {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #f2f2f2;
  justify-content: space-between;
  ::v-deep .el-page-header__left {
    color: #aaaaaa;
  }
  ::v-deep .el-page-header__left::after {
    background-color: transparent;
  }
  .title {
    font-size: 18px;
    color: #4f7da4;
  }
  .add {
	  margin-left:20px;
    width: 60px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 6px;
    color: #ffffff;
    background: #4f7da4;
    cursor: pointer;
  }
}
// 表格样式
::v-deep .el-table {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    flex-direction: row;
    //align-items: center;
    //justify-content: center;
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left: 25px;
    }
  }
}
</style>